/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import {
  empty,
  errorResponse,
  isArray,
  isObject,
  isString,
  prepareResponseData,
  reIndex,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import * as Yup from "yup";
import { Avatar } from "primereact/avatar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// api
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";
import termApi from "../../api/Terms";
import sessionApi from "../../api/Session";
import generalApi from "../../api/General";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import Card from "../../components/card/Card";
import StatCard from "../../components/statcard/StatCard";
import {
  FaBook,
  FaBookOpen,
  FaBookReader,
  FaChartArea,
  FaChartLine,
  FaCheckDouble,
  FaClock,
  FaCloudUploadAlt,
  FaExclamationTriangle,
  FaImage,
  FaQrcode,
  FaStar,
  FaUserEdit,
  FaUserGraduate,
} from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import BoxLoading from "../../components/skeleton/BoxLoading";
import ItemLoading from "../../components/skeleton/ItemLoading";
import TableLoading from "../../components/skeleton/TableLoading";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import SelectField from "../../components/form/SelectField";
import InputField from "../../components/form/InputField";
import FullPageLoader from "../../components/loader/FullPageLoader";
import colors from "../../config/colors";
import Header4 from "../../components/headers/Header4";
import EmptyListResponse from "../../components/emptyDiv/EmptyListResponse";
import CopyTextButton from "../../components/buttons/floatingButton/CopyTextButton";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  classId: Yup.string().required(required),
  comment: Yup.string().optional(),
});

const initialValues = {
  classId: "",
  comment: "",
};

const StudentsProfile = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [studentData, setStudentData] = useState({});
  const [classTitle, setClassTitle] = useState("");
  const [numOfSubjects, setNumOfSubjects] = useState(0);
  const [assignedSubjects, setAssignedSubjects] = useState([]);
  const [assessmentPercentage, setAssessmentPercentage] = useState(0);
  const [percentageLoading, setPercentageLoading] = useState(0);
  const [promotionModalOpen, setPromotionModalOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [classData, setClassData] = useState([]);
  const [activationModalOpen, setActivationModalOpen] = useState(false);
  const [isUploadAvatarModal, setIsUploadAvatarModal] = useState(false);
  const [previewAvatar, setPreviewAvatar] = useState("");
  const [qrCodePath, setQRCode] = useState("");
  const [initials, setInitials] = useState("");
  const [studentReports, setStudentReports] = useState([]);
  const [termId, setTermId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [classId, setClassId] = useState("");
  const [passwordResetModal, setPasswordResetModal] = useState(false);

  const [avatar, setAvatar] = useState(
    !empty(studentData) && !empty(studentData.avatar) ? studentData.avatar : ""
  );
  const fileInputRef = useRef(null);
  const location = useLocation();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // (WIP)
  const { studentId } = useParams();
  const toastTR = useRef(null);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    // check if a new student was added
    if (!studentId) {
      navigate("/404");
    }

    setSessionId(
      !empty(user) && !empty(user.currentSessionId) ? user.currentSessionId : ""
    );
    setTermId(
      !empty(user) && !empty(user.currentTermId) ? user.currentTermId : ""
    );

    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      const studentAdded = !empty(paramState.studentAdded)
        ? paramState.studentAdded
        : false;
      const studentUpdated = !empty(paramState.studentUpdated)
        ? paramState.studentUpdated
        : false;
      if (studentAdded === true || studentUpdated === true) {
        const actionType = studentAdded ? "added" : "updated";
        paramState.studentAdded = false;
        paramState.studentUpdated = false;
        responseDialog(
          "success",
          "Success",
          `Student ${actionType} successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: { studentAdded: false, studentUpdated: false },
          });
        }
      }
    }

    getStudentDetails();
  }, []);

  useEffect(() => {
    getStudentPercentage();
    getClasses();
  }, [studentId, user?._id]);

  const getReports = async (reports) => {
    try {
      setStudentReports([]);
      if (!empty(reports) && isArray(reports)) {
        const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
        const termResponse = await termApi.getTerms(schoolId);
        const response_data = prepareResponseData(termResponse);
        let reIndexedTerms = {};
        let reIndexedSessions = {};
        if (!empty(response_data) && !empty(response_data.response)) {
          reIndexedTerms =
            !empty(response_data.response) && isArray(response_data.response)
              ? reIndex(response_data.response, "_id")
              : {};
        }
        const sessionResponse = await sessionApi.getSessions(schoolId);
        const session_response_data = prepareResponseData(sessionResponse);
        if (
          !empty(session_response_data) &&
          !empty(session_response_data.response)
        ) {
          reIndexedSessions =
            !empty(session_response_data.response) &&
            isArray(session_response_data.response)
              ? reIndex(session_response_data.response, "_id")
              : {};
        }

        const _reports = [];
        for (let i = 0; i < reports.length; i++) {
          const termId =
            !empty(reports[i]) && !empty(reports[i].termId)
              ? reports[i].termId
              : "";
          const sessionId =
            !empty(reports[i]) && !empty(reports[i].sessionId)
              ? reports[i].sessionId
              : "";

          if (!empty(reIndexedSessions[sessionId])) {
            const title = !empty(reIndexedSessions[sessionId].title)
              ? reIndexedSessions[sessionId].title
              : "";
            reports[i].sessionTitle = title;
          }
          if (!empty(reIndexedTerms[termId])) {
            const title = !empty(reIndexedTerms[termId].title)
              ? reIndexedTerms[termId].title
              : "";
            reports[i].termTitle = title;
          }

          if (!empty(reports[i].termTitle) && !empty(reports[i].sessionTitle)) {
            _reports.push(reports[i]);
          }
        }
        _reports.sort((a, b) => {
          const paramA = a.termTitle + a.sessionTitle;
          const paramB = b.termTitle + b.sessionTitle;
          if (paramA < paramB) {
            return -1;
          }
          if (paramA > paramB) {
            return 1;
          }
          return 0;
        });
        setStudentReports(_reports);
      }
    } catch (error) {}
  };

  // function to get all classes
  const getClasses = async () => {
    try {
      const response = await classApi.getClasses('yes');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setClassData([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setClassData(data);
      }
    } catch (error) {}
  };

  /**
   * get student data
   */
  const getStudentDetails = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudentProfile(studentId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        // go to calling url
        navigate(-1);
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to fetch student details"
        );
      }
      const studentDetails =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      const graduated =
        !empty(response_data) && !empty(studentDetails.graduationClassId)
          ? true
          : false;
      const title =
        !empty(response_data) && !empty(studentDetails.classTitle)
          ? studentDetails.classTitle
          : graduated
          ? "Graduated"
          : "N/A";
      const subjects =
        !empty(studentDetails) && !empty(studentDetails.assignedSubjects)
          ? studentDetails.assignedSubjects
          : [];
      const reports =
        !empty(studentDetails) && !empty(studentDetails.reports)
          ? studentDetails.reports
          : [];
      setAvatar(
        !empty(studentDetails) && !empty(studentDetails.avatar)
          ? studentDetails.avatar
          : ""
      );
      setAssignedSubjects(subjects);
      setClassTitle(title);
      setNumOfSubjects(subjects.length);
      getReports(reports);

      if (!empty(studentDetails) && isObject(studentDetails)) {
        setStudentData({
          _id: studentDetails?._id || "",
          fullName: studentDetails?.fullName || "",
          firstName: studentDetails?.firstName || "",
          lastName: studentDetails?.lastName || "",
          middleName: studentDetails?.middleName || "",
          gender: studentDetails?.gender || "",
          regNo: studentDetails?.regNo || "",
          address: studentDetails?.address || "",
          stateOfResidence: studentDetails?.stateOfResidence || "",
          lgaOfResidence: studentDetails?.lgaOfResidence || "",
          stateOfOrigin: studentDetails?.stateOfOrigin || "",
          lgaOfOrigin: studentDetails?.lgaOfOrigin || "",
          nationality: studentDetails?.nationality || "",
          religion: studentDetails?.religion || "",
          dateOfBirth: studentDetails.dateOfBirth || "",
          phoneNumber: studentDetails?.phoneNumber || "",
          email: studentDetails?.email || "",
          currentClassId: studentDetails?.currentClassId || "",
          previousSchool: studentDetails?.previous_school || "",
          hasPaid: studentDetails?.paid || "No",
          graduated: studentDetails?.graduationClassId ? true : false,
          graduationClassId: studentDetails?.graduationClassId ? true : false,
        });
      }

      setClassId(
        !empty(studentDetails) && !empty(studentDetails.currentClassId)
          ? studentDetails.currentClassId
          : ""
      );

      setQRCode(
        !empty(studentDetails.qrCodePath) && isString(studentDetails.qrCodePath)
          ? studentDetails.qrCodePath
          : ""
      );
      const firstNameInitial = studentDetails.firstName.charAt(0);
      const lastNameInitial = studentDetails.lastName.charAt(0);
      return setInitials(`${firstNameInitial}${lastNameInitial}`);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (promotionModalOpen) setPromotionModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);
      const id =
        !empty(studentData) && !empty(studentData._id) ? studentData._id : "";
      if (empty(id)) {
        return responseDialog(
          "error",
          "Error Alert",
          "There are no selected students."
        );
      }
      const comment =
        !empty(values) && !empty(values.comment) ? values.comment : "";
      const _classId =
        !empty(values) && !empty(values.classId) ? values.classId : "";
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";

      const classId =
        !empty(studentData) && !empty(studentData.class)
          ? studentData.class
          : !empty(studentData) && !empty(studentData.currentClassId)
          ? studentData.currentClassId
          : "";
      const response = await studentApi.promoteStudent(
        [id],
        schoolId,
        comment,
        _classId,
        classId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to promote the selected student.`;
        return responseDialog("error", "Error Alert", error_response);
      }

      responseDialog("success", "Success", `Promoted student successfully!`);
      getStudentPercentage();
      return getStudentDetails();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  const getStudentPercentage = async () => {
    setPercentageLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudentPercentage(
        studentId,
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return;
      }
      setAssessmentPercentage(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setPercentageLoading(false);
    }
  };

  // Function to trigger the hidden file input click
  const handleImageFilePickUp = () => {
    fileInputRef.current.click();
  };

  // Function to handle the selected file
  const handleFileUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        // Convert file to Base64 when the file is loaded
        reader.onloadend = async () => {
          const base64String = reader.result;
          setPreviewAvatar(base64String);
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {}
  };

  /**
   * Submit avatar
   * @returns 
   */
  const submitAvatar = async () => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const studentId =
        !empty(studentData) && !empty(studentData._id) ? studentData._id : "";
      const response = await studentApi.uploadStudentAvatar(
        studentId,
        previewAvatar,
        "students"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update school avatar!"
        );
      }

      setAvatar(previewAvatar);

      return responseDialog(
        "success",
        "Success",
        "School avatar updated successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
      setPreviewAvatar("");
      setIsUploadAvatarModal(false);
    }
  };

  /**
   * update qrcode
   * @returns
   */
  const updateQRCode = async () => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(studentData) && !empty(studentData._id) ? studentData._id : "";
      const response = await generalApi.updateQRCode(
        studentId,
        schoolId,
        "students"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update qr-code!"
        );
      }

      let qrCodePath = "";
      if (
        !empty(response_data) &&
        !empty(response_data.response) &&
        !empty(response_data.response.qrCodePath)
      ) {
        qrCodePath = response_data.response.qrCodePath;
      }
      // update qr code
      setQRCode(qrCodePath);

      return responseDialog(
        "success",
        "Success",
        "Update qr-code successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //function to show delete modal
  const showDeleteModal = () => {
    setModalVisible(true);
  };

  //function to hide confirm modal
  const hideDeleteModal = () => {
    setModalVisible(false);
  };

  // hide activation modal
  const hidePromotionModal = () => {
    setPromotionModalOpen(false);
  };
  // hide activation modal
  const hideActivationModal = () => {
    setActivationModalOpen(false);
  };

  const hideModal = (type) => {
    if (type === "reset password") {
      setPasswordResetModal(false);
    }
  };

  const deleteStudent = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.deleteStudent(studentId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to delete student."
        );
      }

      // redirect to students list
      const studentDeleted = true;
      navigate("/students", {
        state: { studentDeleted },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
      return setModalVisible(false);
    }
  };

  //function to activate student on payment
  const activateStudent = async () => {
    try {
      if (activationModalOpen) setActivationModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.activateStudent([studentId], schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to activate student`;
        return responseDialog("error", "Error Alert", error_response);
      }

      await getStudentDetails();
      return responseDialog(
        "success",
        "Success",
        `Activated student successfully!`
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  /**
   * Reset student password
   * @returns
   */
  const resetStudentPassword = async () => {
    try {
      if (activationModalOpen) setActivationModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);

      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.resetStudentPassword(
        studentId,
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          response_data?.response ||
          response_data?.message ||
          `Failed to reset student password`;
        return responseDialog("error", "Error Alert", error_response);
      }

      setPasswordResetModal(false);
      return responseDialog(
        "success",
        "Success",
        `Student password has been successfully updated!`
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  const activateStudentDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={hideActivationModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={() => {
          activateStudent();
        }}
      />
    </div>
  );

  const activateResetPasswordDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={() => hideModal("reset password")}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={() => {
          resetStudentPassword();
        }}
      />
    </div>
  );

  const modalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={hideDeleteModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={deleteStudent}
      />
    </div>
  );

  const goToReportSheet = () => {
    if (
      !empty(studentId) &&
      !empty(sessionId) &&
      !empty(termId) &&
      !empty(classId)
    ) {
      let _classId = classId;
      if (classId?.toLowerCase() === 'graduated') {
        _classId = studentData?.graduationClassId || '';
      }
      return navigate(
        `/student/${studentId}/report-sheet/session/${sessionId}/term/${termId}/class/${_classId}`, {
          state: { graduated: !empty(studentData?.graduationClassId) ? true : false }
        }
      );
    }
  };

  const updateStudentProfile = () => {
    navigate(`/student/${studentId}/update`);
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Student Profile" />
          {/* end menu header */}

          {classId !== 'graduated' &&
            <div className="mt-20 mb-10">
              <>
                <ButtonIcon
                  borderColor={colors.primary}
                  backgroundColor={colors.primary}
                  color={colors.white}
                  buttonText="Attendance"
                  iconMarginRight={8}
                  icon={<FaCheckDouble size={12} />}
                  width={150}
                  height={30}
                  marginRight={1}
                  onClick={() =>
                    navigate(`/attendance/history`, {
                      replace: true,
                      state: { classId },
                    })
                  }
                />
                <ButtonIcon
                  borderColor={colors.primary}
                  backgroundColor={colors.primary}
                  color={colors.white}
                  buttonText="Time Table"
                  iconMarginRight={8}
                  icon={<FaClock size={12} />}
                  width={150}
                  height={30}
                  onClick={() =>
                    navigate(`/time-table/home`, {
                      replace: true,
                      state: { classId },
                    })
                  }
                />
              </>
            </div>}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div id="main_left_box">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Class Title"
                        entry={classTitle}
                        icon={<FaUserGraduate className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Subjects"
                        entry={numOfSubjects}
                        icon={<FaBookReader className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !percentageLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Assessment"
                        entry={assessmentPercentage + "%"}
                        icon={<FaChartLine className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Attendance"
                      entry="N/A"
                      icon={<FaChartArea className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              {/* chart */}
              <div className="chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Student Bio-Data" />
                      <div className="dashboard_school_list">
                        <div className="avatar-container flex">
                          <div className="staff-avatar-container">
                            {!empty(avatar) ? (
                              <Avatar
                                image={avatar}
                                shape="circle"
                                style={{
                                  width: 200,
                                  height: 200,
                                  padding: 10,
                                  marginLeft: 15,
                                }}
                                className="mb-10"
                              ></Avatar>
                            ) : (
                              <Avatar
                                label={initials}
                                shape="circle"
                                style={{
                                  width: 150,
                                  height: 150,
                                  fontSize: 70,
                                  marginLeft: 15,
                                }}
                              ></Avatar>
                            )}
                            <p className="fs-18 bold">{studentData.fullName}</p>
                            {!studentData.graduated && (
                              <div>
                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  borderColor="transparent"
                                  buttonText="Update Avatar"
                                  iconMarginRight={8}
                                  icon={<FaCloudUploadAlt />}
                                  fontWeight="bold"
                                  onClick={() => setIsUploadAvatarModal(true)}
                                />
                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  marginTop={-2}
                                  borderColor="transparent"
                                  buttonText="Update Profile"
                                  iconMarginRight={8}
                                  icon={<FaUserEdit />}
                                  fontWeight="bold"
                                  onClick={() => updateStudentProfile()}
                                />
                              </div>
                            )}
                            {!isLoading && studentData?.hasPaid !== "Yes" &&
                              !studentData?.graduated ? (
                                <>
                                  <div
                                    className="mt-10 assessment_not_paid mb-10"
                                    style={{
                                      width: 200,
                                      textAlign: "center",
                                      fontSize: 14,
                                    }}
                                  >
                                    <FaExclamationTriangle
                                      color={colors.danger}
                                      size={25}
                                    />
                                    <div>
                                      This student has an outstanding portal
                                      levy
                                    </div>
                                  </div>
                                  <div className="flex w-100pc ml-25">
                                    <ButtonIcon
                                      borderColor={colors.danger}
                                      backgroundColor={colors.danger}
                                      color={colors.white}
                                      buttonText="Activate Account"
                                      onClick={() =>
                                        setActivationModalOpen(true)
                                      }
                                    />
                                  </div>
                                </>
                              ) : 
                                <div className="personal-info-list mt-20">
                                  <div className="profile-title">
                                    Status:
                                  </div>
                                  <div className="profile-value">
                                    Active
                                  </div>
                                </div>
                              }
                          </div>

                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Registration Number:
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.regNo
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">First Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.firstName || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Last Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.lastName || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Middle Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.middleName || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Gender: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.gender
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">Address: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.address || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.phoneNumber || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Email: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData?.email || '--'
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Date of Birth:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.dateOfBirth
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Nationality: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.nationality
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.stateOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="other-staff-info-header mb-20">
                          <MainHeader title="Other Information" />
                        </div>
                        <div className="flex sm-reverse-direction-vertical other-staff-info col-g-12">
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.lgaOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Nationality: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.nationality
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Regigion: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.religion
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Origin:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.stateOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Origin:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.lgaOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Previous School:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  studentData.previousSchool
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block ">
                            <img
                              width={250}
                              height={250}
                              src={qrCodePath}
                              alt="qrcode"
                            />
                            <ButtonIcon
                              height={40}
                              color={colors.primary}
                              backgroundColor={colors.lightgray}
                              width={180}
                              marginTop={-1}
                              borderColor="transparent"
                              buttonText="Update QR-Code"
                              marginLeft={4}
                              iconMarginRight={8}
                              icon={<FaQrcode />}
                              fontWeight="bold"
                              onClick={() => updateQRCode()}
                            />
                          </div>
                        </div>
                        <>
                          <div className="other-staff-info-header">
                            <p
                              style={{
                                color: colors.danger,
                                fontWeight: "bold",
                                fontSize: 16,
                                borderBottom: "1px solid red",
                                paddingBottom: 8,
                              }}
                            >
                              Danger Zone
                            </p>
                          </div>
                          <div className="other-staff-info">
                            <div className="danger-zone-item mt-40">
                              <div>
                                <div className="mt-10 mb-10 bold fs-14">
                                  Promote/Demote Student
                                </div>
                                <span className="fs-16 text-italic">
                                  Change student's class
                                </span>
                              </div>
                              <div className="mt-10">
                                <ButtonIcon
                                  borderColor={colors.primary}
                                  backgroundColor={colors.white}
                                  color={colors.primary}
                                  buttonText="Promote/Demote"
                                  width={150}
                                  onClick={() => setPromotionModalOpen(true)}
                                />
                              </div>
                            </div>

                            <div className="danger-zone-item">
                              <div>
                                <div className="mb-10 bold fs-14">
                                  Reset Password
                                </div>
                                <span className="fs-16 text-italic">
                                  Reset student password to default (Student
                                  RegNo.)
                                </span>
                              </div>
                              <div className="mt-10">
                                <ButtonIcon
                                  borderColor={colors.danger}
                                  backgroundColor={colors.white}
                                  color={colors.danger}
                                  buttonText="Reset Password"
                                  width={150}
                                  onClick={() => setPasswordResetModal(true)}
                                />
                              </div>
                            </div>

                            <div className="danger-zone-item">
                              <div>
                                <div className="mb-10 bold fs-14">
                                  Delete Student
                                </div>
                                <span className="fs-16 text-italic">
                                  Once you delete a student, there is no going
                                  back. Please be certain.
                                </span>
                              </div>
                              <div className="mt-10">
                                <ButtonIcon
                                  borderColor={colors.danger}
                                  backgroundColor={colors.white}
                                  color={colors.danger}
                                  buttonText="Delete Student"
                                  onClick={showDeleteModal}
                                  width={150}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </>
                  }
                  addStyle="student_list_box"
                />
              </div>
              {/* end chart */}

              {/*  */}
            </div>
            {/* end of left box */}

            {/* right box */}
            <div id="main_right_box">
              <div className="main_right_boxes">
                {!studentData.graduated && (
                  <Card
                    children={
                      <>
                        <MainHeader title="Class Subjects" />
                        <div className="mt-10">
                          {!isLoading ? (
                            assignedSubjects.map((item, index) => {
                              return (
                                <p
                                  key={index}
                                  className="mb-10 flex space-between bio-data-item"
                                >
                                  <span>
                                    <FaStar
                                      color={colors.orange}
                                      style={{ marginRight: 8, fontSize: 12 }}
                                    />
                                    {!empty(item) && !empty(item.title)
                                      ? item.title
                                      : ""}
                                  </span>
                                </p>
                              );
                            })
                          ) : (
                            <TableLoading rows={5} cols={1} header={false} />
                          )}
                        </div>
                      </>
                    }
                    addStyle="card_adjust"
                  />
                )}
                <Card
                  children={
                    <>
                      <MainHeader title="Performance History" />
                      <div className="mb-20">
                        <NavLink
                          to={`/student/${studentId}/transcript`}
                          style={{
                            textDecoration: "none",
                            color: colors.primary,
                            fontSize: 14,
                          }}
                        >
                          <strong>
                            <span>
                              <FaBookOpen size={12} />{" "}
                            </span>
                            <span>Go to Transcript</span>
                          </strong>
                        </NavLink>
                        <div
                          onClick={goToReportSheet}
                          style={{
                            color: colors.primary,
                            marginTop: 10,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          <strong>
                            <span>
                              <FaBook size={12} />{" "}
                            </span>
                            <span>Go to Current Report Sheet</span>
                          </strong>
                        </div>
                      </div>
                      <div className="mt-10">
                        <Header4 className="mb-10 text-primary"><span>Other Results</span></Header4>
                        {
                          !isLoading ? (
                            !empty(studentReports) ? 
                              studentReports?.map((item, index) => {
                                const termTitle =
                                  !empty(item) && !empty(item.termTitle)
                                    ? item.termTitle
                                    : "";
                                const sessionTitle =
                                  !empty(item) && !empty(item.sessionTitle)
                                    ? item.sessionTitle
                                    : "";
                                const termId =
                                  !empty(item) && !empty(item.termId)
                                    ? item.termId
                                    : "";
                                const classId =
                                  !empty(item) && !empty(item.classId)
                                    ? item.classId
                                    : "";
                                const sessionId =
                                  !empty(item) && !empty(item.sessionId)
                                    ? item.sessionId
                                    : "";
                                const cumulativeScore =
                                  !empty(item) && !empty(item.cumulativeScore)
                                    ? item.cumulativeScore
                                    : "";
                                const average =
                                  !empty(item) && !empty(item.average)
                                    ? item.average + "%"
                                    : "";
                                const grade =
                                  !empty(item) && !empty(item.grade)
                                    ? item.grade
                                    : "";
                                const remark =
                                  !empty(item) && !empty(item.remark)
                                    ? item.remark
                                    : "";
                                const position =
                                  !empty(item) && !empty(item.position)
                                    ? item.position
                                    : "";
                                return (
                                  <div
                                    key={index}
                                    className="flex direction-column bio-data-item mt-10"
                                  >
                                    {!empty(classId) ? (
                                      <NavLink
                                        to={`/student/${studentId}/report-sheet/session/${sessionId}/term/${termId}/class/${classId}`}
                                        style={{
                                          textDecoration: "none",
                                          color: colors.primary,
                                        }}
                                      >
                                        <FaStar
                                          color={colors.orange}
                                          style={{ marginRight: 8, fontSize: 12 }}
                                        />
                                        {termTitle} ({sessionTitle})
                                      </NavLink>
                                    ) : (
                                      <span>
                                        <FaStar
                                          color={colors.orange}
                                          style={{ marginRight: 8, fontSize: 12 }}
                                        />
                                        {termTitle} ({sessionTitle})
                                      </span>
                                    )}
                                    <ul style={{ padding: "0 35px", marginTop: 5 }}>
                                      <li style={{ marginBottom: 8 }}>
                                        <span>
                                          <strong>CumulativeScore:&nbsp;</strong>
                                        </span>
                                        <span>{cumulativeScore}</span>
                                      </li>
                                      <li style={{ marginBottom: 8 }}>
                                        <span>
                                          <strong>Average:&nbsp;</strong>
                                        </span>
                                        <span>{average}</span>
                                      </li>
                                      <li style={{ marginBottom: 8 }}>
                                        <span>
                                          <strong>Grade:&nbsp;</strong>
                                        </span>
                                        <span>{grade}</span>
                                      </li>
                                      <li style={{ marginBottom: 8 }}>
                                        <span>
                                          <strong>Position:&nbsp;</strong>
                                        </span>
                                        <span>{position}</span>
                                      </li>
                                      <li style={{ marginBottom: 8 }}>
                                        <span>
                                          <strong>Remark:&nbsp;</strong>
                                        </span>
                                        <span>{remark}</span>
                                      </li>
                                    </ul>
                                  </div>
                                );
                              }) : <EmptyListResponse />
                        ) : (
                          <TableLoading rows={5} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="card_adjust"
                />
              </div>
            </div>
            {/* end of right box */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
        {isLoading && <FullPageLoader visible={isLoading} />}
      </AppWrapper>

      <Dialog
        visible={modalVisible}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={modalFooter}
        onHide={hideDeleteModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          <p>
            Are you sure you want to delete the student?
            <br />
            <em>
              <strong style={{ color: colors.danger }}>
                PS: This operation can not be undone.
              </strong>
            </em>
          </p>
        </div>
      </Dialog>
      <Dialog
        visible={promotionModalOpen}
        className="promotion-modal"
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Promotion"
        modal
        onHide={hidePromotionModal}
      >
        <div
          className="confirmation-content"
          style={{ display: "flex", alignItems: "center" }}
        >
          {
            <>
              <div className="form-container">
                <div>
                  <p>
                    <strong>Current Class:</strong> {classTitle}
                  </p>
                  <br></br>
                  <p className="flex align-center">
                    You are about to promote the selected student(s). Ensure
                    that you are promoting the right students to the right
                    class.
                  </p>
                </div>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange }) => (
                    <Form style={{ width: "100%" }}>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          columnGap: 12,
                        }}
                      >
                        <SelectField
                          labelTitle="Promote to"
                          placeholder="Select class"
                          name="classId"
                          required={true}
                          options={classData}
                          height={50}
                          valueKey="id"
                          selectedOption={values.classId}
                          handleChangeFunc={handleChange}
                          customPlaceholder="Graduated"
                          customValue="graduated"
                        />
                      </div>
                      <div 
                        style={{
                          width: "100%",
                          display: "flex",
                          columnGap: 12,
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <InputField
                          placeholder="Enter description"
                          name="comment"
                          height={150}
                          as="textarea"
                          row={9}
                          cols={8}
                          labelTitle="Comment"
                        />
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <ButtonIcon
                          height={45}
                          marginTop={5}
                          color="#ffffff"
                          backgroundColor={colors.primary}
                          width={300}
                          borderColor={colors.primary}
                          buttonText="Promote"
                          type="submit"
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </>
          }
        </div>
      </Dialog>

      <Dialog
        visible={activationModalOpen}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={activateStudentDialogFooter}
        onHide={hideActivationModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          {
            <>
              <p>
                Are you sure you want to <strong>activate</strong> this student?{" "}
                <br />
                <br />
                By clicking "Yes", you are confirming that{" "}
                <strong>
                  {studentData.lastName + " " + studentData.firstName + " has"}
                </strong>{" "}
                made portal payment for this term.
                <br />
                <br />
                <em style={{ color: colors.danger }}>
                  <strong>Note:</strong> This action cannot be undone.
                </em>
              </p>
            </>
          }
        </div>
      </Dialog>

      <Dialog
        visible={passwordResetModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Password Reset"
        modal
        footer={activateResetPasswordDialogFooter}
        onHide={() => hideModal("reset password")}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          {
            <>
              <p>
                Are you sure you want to <strong>reset</strong> this student's
                password? <br />
                <br />
                By clicking "Yes", you are confirming that you want to reset the
                password for the student{" "}
                <strong>
                  {studentData.lastName + " " + studentData.firstName}
                </strong>{" "}
                <br />
                <br />
                <em style={{ color: colors.danger }}>
                  <strong>Note:</strong> This action cannot be undone.
                </em>
              </p>
            </>
          }
        </div>
      </Dialog>

      <Dialog
        visible={isUploadAvatarModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Action"
        modal
        onHide={() => {
          setPreviewAvatar("");
          setIsUploadAvatarModal(false);
        }}
      >
        <div
          className="confirmation-content"
          style={{
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="avatar-preview-box mb-20">
            {!empty(previewAvatar) ? (
              <img src={previewAvatar} alt="" />
            ) : (
              <FaCloudUploadAlt size={80} />
            )}
          </div>
          {<span>Select image to upload</span>}

          <div className="flex flex-center w-100pc col-g-12">
            <ButtonIcon
              height={40}
              marginTop={1}
              color={colors.tomato}
              backgroundColor={colors.lightgray}
              width={170}
              borderColor={colors.lightgray}
              buttonText="Select Avatar"
              iconMarginRight={8}
              icon={<FaImage />}
              fontWeight="bold"
              onClick={handleImageFilePickUp}
            />
            {previewAvatar ? (
              <ButtonIcon
                height={40}
                marginTop={1}
                color={colors.primary}
                backgroundColor={colors.lightgray}
                width={180}
                borderColor={colors.lightgray}
                buttonText="Update Avatar"
                iconMarginRight={8}
                icon={<FaCloudUploadAlt />}
                fontWeight="bold"
                onClick={() => submitAvatar()}
              />
            ) : null}
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        </div>
      </Dialog>
        <CopyTextButton
          width={65}
          height={65}
          right={35}
          actionTitle="Copy student Id"
          successMessage="Copied student Id"
          copyText={studentData?.regNo || ''}
        />
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default StudentsProfile;
